import { renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "horizontal-paging-content",
  ref: "parentContent"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", {
    class: "horizontal-paging",
    ref: "scroll",
    onTouchStart: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.touchStart(...args))),
    onTouchMove: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.touchMove(...args))),
    onTouchend: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.touchEnd(...args)))
  }, [
    _createVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ], 512)
  ], 544))
}